// 课程类型单一来源：1机构课(红) / 2校内课(青) / 3特色课(黄) / 4其他(紫)
// 全项目统一引用此处，勿在各页面另写同名 helper（历史重复副本已合并到此处）。
// type=4 的"紫"为 Vant 无内置色，用自定义类型 "other" + App.vue 全局 .van-tag--other 样式实现。
export const courseTypeText = (t) => {
  switch (Number(t)) {
    case 1: return "机构课";
    case 2: return "校内课";
    case 3: return "特色课";
    case 4: return "其他";
    default: return "未知";
  }
};

export const courseTypeType = (t) => {
  switch (Number(t)) {
    case 1: return "danger"; // 红
    case 2: return "primary"; // 青（主题色）
    case 3: return "warning"; // 黄
    case 4: return "other"; // 紫（自定义，配合 .van-tag--other 全局样式）
    default: return "default";
  }
};
